// CreditBurnTicker — Phase 6.
//
// Tiny composer-footer line for signed-in users showing this-week vs
// last-week credit usage. Only renders when the trend is *positive*
// (more usage = more practice = path to mastery). Stays silent
// otherwise so it never feels punishing.
import { Flame } from "lucide-react";
import { useWeeklyCreditTrend } from "@/hooks/useWeeklyCreditTrend";

const CreditBurnTicker = () => {
  const { data } = useWeeklyCreditTrend();

  // Only show when we have a positive delta worth celebrating.
  if (!data || data.pctChange == null || data.pctChange <= 0) return null;

  return (
    <span
      className="inline-flex items-center gap-1 text-primary"
      title={`${data.thisWeekUsed.toLocaleString()} points spent this week vs ${data.lastWeekUsed.toLocaleString()} last week`}
    >
      <Flame className="w-3 h-3" />
      <span>
        +{data.pctChange}% credits this week — that's the path to mastery.
      </span>
    </span>
  );
};

export default CreditBurnTicker;